<template>
	<section v-if="news.length !== 0" class="iv2-section-news theme__sub-bg">
		<div class="container">
			<div class="row clearfix">
				<div class="column full text-center">
					<p class="size-14">{{ subtitle }}</p>
					<h3 class="theme__heading-text">{{ title }}</h3>
				</div>
				<div class="column full">
					<div class="spacer height-40"></div>
				</div>
				<div v-if="news" class="column full">
					<div class="row">
						<div v-for="item in limitCount" :key="item.id" class="iv2-top-news-item mb-5 col-md-6 col-xl-4">
							<router-link :to="{ name: 'newsDetail', params: { id: item.id }}" class="iv2-top-news-item__link">
								<div class="iv2-top-news-item__img fit-img">
									<picture>
										<source type="image/webp" :srcset="item.thumbnail + $t('general.image_webp')">
										<img class="m-0" :src="item.thumbnail" :alt="'「' + item.title + '」' + $t('news.alt')">
									</picture>
								</div>

								<div class="iv2-top-news-item__data mt-4">
									<div class="row">
										<div class="col-6">
											<small v-if="item.opened_at !== null" class="iv2-top-news-item__date">{{ item.opened_at | moment }}</small>
											<small v-if="isAfter(setDatetime(item.opened_at),end)"
												class="iv2-top-news-item__new ml-1"
											>{{ $t('news.new_label') }}</small>
										</div>
										<div class="col-6">
											<small class="iv2-top-news-item__label d-block">{{ item.category_name }}</small>
										</div>
									</div>
								</div>
								<h3 class="iv2-top-news-item__title">{{ item.title }}</h3>
							</router-link>
						</div>
					</div>
				</div>
				<div class="column full">
					<div class="text-center">
						<span>
							<router-link
								to="/news"
								class="iv2-top-news-btn theme__main-btn is-btn is-btn-ghost2 size-18"
							>{{ $t('page.news_button') }}</router-link>
							<!-- <a
								v-if="blog.is_linked_blog == 1"
								:href="blog.url"
								target="_blank"
								rel="noopener"
								class="iv2-top-news-btn theme__main-btn is-btn is-btn-ghost2 size-18"
							>
								<i class="fas fa-rss"></i>
								{{ $t('page.rss_button') }}
							</a> -->
						</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import moment from "moment";

export default {
	props: ["items", "blog"],

	data() {
		return {
			news: [],
			title: "",
			subtitle: "",

			limit: "",
			start: "",
			end: moment().format(),
		};
	},

	created() {
		this.limit = this.items.display_news_number;
	},

	mounted() {
		if(this.$route.query.mode == 'preview') {
			this.axios.get("/preview/news", {
				headers: {
					Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
				}
			}).then(({data}) => {
				this.news = data.response.data;
				this.title = data.response.title;
				this.subtitle = data.response.subtitle;
			});
		}else{
			this.axios.get("/news").then(({data}) => {
				this.news = data.response.data;
				this.title = data.response.title;
				this.subtitle = data.response.subtitle;
			});
		}
	},

	methods: {
		isAfter: function (start, end) {
			return moment(start).isAfter(end);
		},

		setDatetime: function (start) {
			return moment(start).add(13, "days");
		},
	},

	computed: {
		limitCount() {
			return this.news.slice(0, this.limit);
		},
	},

	filters: {
		moment: function (created) {
			return moment(created).format("YYYY年MM月DD日");
		},
	},
};
</script>

<style lang="scss">
.iv2-section-news {
	padding: 80px 0;

	.iv2-top-news-item .iv2-top-news-item__link {
		display: block;
		text-decoration: none;

		&:hover .iv2-top-news-item__img {
			opacity: 0.7;
		}

		.iv2-top-news-item__img {
			height: 200px;
			-webkit-transition: 0.3s;
			transition: 0.3s;
		}

		.iv2-top-news-item__title {
			font-size: 1.1rem;
			font-weight: bold;
		}

		.iv2-top-news-item__new {
			color: #a83535;
		}

		.iv2-top-news-item__label {
			width: 100%;
			text-align: center;
			border: 1px solid;
		}
	}

	.iv2-top-news-btn {
		letter-spacing: 2px;
		max-width: 100%;
		width: 300px;
		padding-top: 15px;
		padding-bottom: 15px;
		margin: 10px 13px;
	}
}

@media (max-width: 1199px) {
	.iv2-section-news {
		.iv2-top-news-item {
			.iv2-top-news-item__link {
				.iv2-top-news-item__title {
					font-size: 1.1rem;
				}
			}
		}

		.iv2-top-news-btn {
			width: 300px;
		}
	}
}
</style>
